import React, {PureComponent} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/index'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import moment from 'moment'
import { Card, Form } from 'antd'
import { TableComp } from 'sz-react-utils'
import StudentHeader from '../../components/studentHeader/index'

import Request from '../../request'
import {connect} from 'react-redux'
import StudentInfo from '../../components/StudentInfo'


@Form.create()
class StudentCallHistory extends PureComponent {
    state = {
        studentId: '',
        count: 0,
        completeInfo:{},
        callHistory:[]
    }

    async getCallHistory() {
        const {mobile} = this.state.completeInfo;
        let response = await Request.getCallHistory(mobile);
        if(response.success) {
            this.setState({callHistory:response.callHistory})
        }
    }

    refreshFxn = () => {
        this.setState({refreshChild: !this.state.refreshChild})
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }
    async componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search)
        let studentId = searchParams.get('id')
        this.setState({studentId: studentId}, () => {
        })
        let {doc} = await Request.getInquiry(studentId)
        this.setState({completeInfo: doc})
        this.getCallHistory()
    }
    render() {

        const {completeInfo} = this.state
        const columns = [
            {
              title: 'Agent Number',
              key: 'callerFromNumber',
            },
            {
              title: 'Start Time',
              key: 'startTime',
              render: (text, record) => {
                var startTime = new Date(record.startTime * 1000);
                return (
                  <div>
                    {
                      record.startTime ? 
                        <div>{moment(startTime).format('lll')}</div>
                      : 'NA'
                    }              
                  </div>
                )
              }
            },
            {
              title: 'End Time',
              key: 'endTime',
              render: (text, record) => {
                var endTime = new Date(record.endTime * 1000);
                return (
                  <div>
                    {
                      record.endTime ? 
                        <div>{moment(endTime).format('lll')}</div>
                      :'NA'
                    }              
                  </div>
                )
              }
            },
            {
              title: 'Log Message',
              key: 'logMessage',
              width: '300px'
            },
            {
              title: 'Duration',
              key: 'duration',
            },
            {
              title: 'File',
              key: 'filePath',
              render: (text, record) => {
                return (
                  <div>
                    {
                      record.filePath ?
                        <div><a target="_blank" rel='noopener noreferrer' href={record.filePath}>View</a></div>
                      :'NA'
                    }              
                  </div>
                )
              }
            },
            {
              title: 'call Initiated By',
              key: 'callInitiatedBy',
              dataIndex: 'callInitiatedBy',
              render: (text, record) => {
                return (
                  <div>
                    <div>{record.callInitiatedBy != null ? record.callInitiatedBy.name : ""}</div>
                    <small>{record.callInitiatedBy ? moment(record.callInitiatedBy.time).format('lll') : '' }</small>
                  </div>
                )
              }
            },
            {
              title: 'Updated By',
              key: 'lastUpdatedByName',
              dataIndex: 'lastUpdatedByName',
              render: (text, record) => {
                return (
                  <div>
                    <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
                    <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
                  </div>
                )
              }
            }
          ];

        return (
            <PageHeaderWrapper title={'Student Calls History'}>

                {
                    completeInfo ? <div style={{marginBottom: 10}}>
                        <StudentHeader
                            info={this.state.studentId}
                            data={this.state.completeInfo}
                            done={() => {
                            }}
                            dispatch={this.props.dispatch}
                        />
                    </div> : null
                }

                {
                    completeInfo ? <Card bordered={true} style={{marginBottom: 10}}>
                        <StudentInfo
                            info={completeInfo}
                        />
                    </Card> : null
                }

                <Card bordered={true}>
                    <TableComp
                    ref={this.table}
                    columns={columns}
                    dataSource={this.state.callHistory}
                    extraProps={{scroll: {x: 900}}}
                    pagination={{
                    showSizeChanger: true,
                    defaultPageSize: 50,
                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                    }}
                />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StudentCallHistory)
